import { put, call, take, fork } from 'redux-saga/effects'
import { userGetService } from '../../api/user'
import { userGetSuccess } from '../../reducers/user/action'
import { USER_GET } from '../../reducers/user/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* userGetFlow(payload) {
  try {
    const { id } = payload
    const response = yield call(userGetService, id)

    yield put(userGetSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* userGetWatcher() {
  while (true) {
    const action = yield take(USER_GET)
    const { payload } = action

    yield fork(generalSaga, userGetFlow, payload)
  }
}
